import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "uefa-upcoming-list__card-header" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Élő stream ")
const _hoisted_4 = { class: "uefa-upcoming-list__card-content" }
const _hoisted_5 = { class: "uefa-upcoming-list__card-items" }
const _hoisted_6 = { class: "uefa-upcoming-list__card-item" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "uefa-upcoming-list__card-date" }
const _hoisted_9 = { class: "uefa-upcoming-list__card-time" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_rtl_plus = _resolveComponent("rtl-plus")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["uefa-upcoming-list", { 'uefa-upcoming-list--slider': _ctx.showSlider }]),
    "data-slider-pane": ""
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contents, (content) => {
      return (_openBlock(), _createElementBlock("a", {
        class: "uefa-upcoming-list__card",
        href: content.url
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_rtl_plus, {
            "with-slogan": false,
            height: "16",
            alt: "RTL+"
          }),
          _hoisted_3
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(content.items, (item) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("img", {
                  src: item.logo,
                  width: "40",
                  height: "40",
                  loading: "lazy"
                }, null, 8, _hoisted_7),
                _createTextVNode(" " + _toDisplayString(item.name), 1)
              ]))
            }), 256))
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createTextVNode(_toDisplayString(_ctx.$d(content.date, 'date')) + " ", 1),
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$d(content.date, 'time')), 1)
          ])
        ])
      ], 8, _hoisted_1))
    }), 256))
  ], 2))
}